import { makeStyles } from '@mui/styles';
import { neutral7 } from 'apollo-react/colors';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import ChartIcon from '../components/ChartIcon';
import NewControl from '../components/NewControl';
import { PALETTE_MAPPING, REPORT_CONTROL_TYPE } from '../constants/report-designer.constants';
import DynamicControl from '../DynamicControl';
import { getChildrenWithControlType } from '../selectors/report-designer.selectors';
import { isExpressionValue } from '../utils/report-designer.utils';

const useStyles = makeStyles({
  title: {
    textAlign: 'center',
    padding: '7px 0px',
    border: `1px solid ${neutral7}`,
    borderRadius: 5,
    marginBottom: 7,
  },
  mainContainer: {
    display: 'flex',
    overflowX: 'auto',
  },
  dataContainer: {
    marginLeft: 10,
    width: '100%',
  },
  itemContainer: {
    minHeight: 50,
    display: 'flex',
  },
  itemLabel: {
    width: 80,
    marginTop: 7,
  },
  chartGroupsContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    paddingBottom: 30,
  },
});

const SSChart = ({ label, chartType, id, palette }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const childrenWithControlType = useSelector(
    (state) => getChildrenWithControlType(state, { id }),
    equalityFn
  );

  const title = !label
    ? translateString('Chart Title')
    : isExpressionValue(label)
    ? translateString('Expression')
    : label;

  const {
    ssChartGroup: chartGroups = [],
    ssChartValue: chartValues = [],
  } = childrenWithControlType;

  return (
    <>
      <div className={classes.title}>{title}</div>
      <div className={classes.mainContainer}>
        <ChartIcon chartType={chartType} color={PALETTE_MAPPING[palette]} />
        <div className={classes.dataContainer}>
          <div className={classes.itemContainer}>
            <span className={classes.itemLabel}>{translateString('Value(y):')}</span>
            <div>
              <div>
                {chartValues.map((id) => (
                  <DynamicControl key={id} id={id} />
                ))}
              </div>
              <NewControl parentId={id} controlType={REPORT_CONTROL_TYPE.CHART_VALUE} />
            </div>
          </div>
          <div className={classes.itemContainer} style={{ marginTop: 10 }}>
            <span className={classes.itemLabel}>{translateString('Group(x):')}</span>
            {!chartGroups.length && (
              <NewControl parentId={id} controlType={REPORT_CONTROL_TYPE.CHART_GROUP} />
            )}
            <div className={classes.chartGroupsContainer}>
              {chartGroups.map((id) => (
                <DynamicControl key={id} id={id} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SSChart;
